import React from "react";
import Select from "react-select";

const CustomSelect = ({
  options,
  value,
  onChange,
  placeholder,
  isSearchable,
  isClearable,
  isDisabled,
  className,
  id,
  menuPosition = "fixed",
}) => {
  const selectedOption = options.find((option) => option.value == value);
  return (
    <div className={`${className}`}>
      <Select
        options={options}
        value={selectedOption || null}
        onChange={onChange}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        classNamePrefix="custom-select"
        className="custom-select-container"
        controlClassName="custom-select-control"
        menuClassName="custom-select-menu"
        optionClassName="custom-select-option"
        singleValueClassName="custom-select-single-value"
        id={id}
        menuPosition={menuPosition}
        // menuPlacement="auto"
        closeMenuOnSelect={true}
      />
    </div>
  );
};

export default CustomSelect;
